export default "__VITE_ASSET__d0nVEoQs__"